/* eslint-disable */
import { produce } from "immer";
import {
  MEMBER_TYPE_FETCH_START,
  MEMBER_TYPE_FETCH_SUCCESS,
  MEMBER_TYPE_FETCH_FAILURE,
} from "../actions/types";

const memberType = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case MEMBER_TYPE_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case MEMBER_TYPE_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data.data;
        draft.fetching = false;
      });
    case MEMBER_TYPE_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default memberType;
